const correctResponsesActions = {
    types: {
        CORRECT_RESPONSES_SET: 'CORRECT_RESPONSES_SET',
        CORRECT_RESPONSES_CLEAR: 'CORRECT_RESPONSES_CLEAR',
    },

    setCorrectResponses(correctResponses) {
        return { type: this.types.CORRECT_RESPONSES_SET, correctResponses };
    },

    clearCorrectResponses() {
        return { type: this.types.CORRECT_RESPONSES_CLEAR };
    },
};

export default correctResponsesActions;
